import { render } from "./tw-checkbox.vue?vue&type=template&id=413333c6"
import script from "./tw-checkbox.vue?vue&type=script&lang=js"
export * from "./tw-checkbox.vue?vue&type=script&lang=js"
script.render = render

export default script